import React from 'react';
import globalHook from 'use-global-hook';

let busy = false;

const initialState = {
  name: null,
  value: null,
  ...window.initialCSRF,
};

const actions = {
  refresh: store => {
    if (!busy) {
      busy = true;
      fetch('/api/csrf-token')
        .then(result => {
          return result.json();
        })
        .then(state => {
          store.setState(state);
          busy = false;
        })
        .catch(() => {
          busy = false;
        });
    }
  },
};

export default globalHook(React, initialState, actions);
